import { Loader, Tabs } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button";
import CompleteProfile from "../../components/CompleteProfile";
import Page from "../../components/Page";
import { backendUrl } from "../../constants";
import AccountInfo from "./AccountInfo";
import BlockUser from "./BlockUser";
import Password from "./Password";
import back from "../../assets/back.svg";

import "./styles.css";
import MyPosts from "./MyPosts";
import { showNotification } from "@mantine/notifications";
import routeNames from "../../routes/routeNames";

const Index = () => {
  const navigate = useNavigate();
  let userData = JSON.parse(localStorage.getItem("userData"));
  let user = userData?.id;

  const [tab, setTab] = useState("1");
  const [blockUser, setBlockUser] = useState({ userId: user });
  const [acountInfo, setAccountInfo] = useState({ userId: user });
  const [updatePass, setUpdatePass] = useState({ userId: user });
  const [refetch, setRefetch] = useState(false);
  const { tab: currentTab } = useParams();

  useEffect(() => {
    if (currentTab) {
      setTab(currentTab);
    }
  }, [currentTab]);

  //acount info
  useEffect(() => {
    const options = {
      method: "GET",
    };
    fetch(`${backendUrl}user/getAccountInfo/${user}`, options)
      .then((response) => response.json())
      .then((response) => {
        Object.keys(response.data[0]).map((key) => {
          let value = response.data[0][key];
          if (key === "state" || key === "timeZone")
            value = response.data[0][key]?._id;
          setAccountInfo((v) => ({ ...v, [key]: value }));
        });
      })
      .catch((err) => {});
  }, [user]);

  const handleSaveData = () => {
    if (tab === "1") {
      if (acountInfo?.firstName.length < 1 || acountInfo?.lastName.length < 1) {
        showNotification({
          message: "Please enter full name.",
          color: "red",
        });
      } else {
        const options = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "content-type": "application/json",
          },
          body: JSON.stringify(acountInfo),
        };

        fetch(`${backendUrl}user/saveAccountInfo`, options)
          .then((response) => response.json())
          .then((response) => {
            showNotification({
              message: "Account Settings updated Successfully!",
              color: "green",
            });
          })
          .catch((err) => console.error(err));
      }
    } else if (tab === "2") {
      if (updatePass.password === updatePass.password2) {
        setUpdatePass((p) => {
          const { password2, ...rest } = p;
          return rest;
        });
        const options = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "content-type": "application/json",
          },
          body: JSON.stringify(updatePass),
        };

        fetch(`${backendUrl}user/changePassword`, options)
          .then((response) => response.json())
          .then((response) => {
            response.status
              ? showNotification({
                  title: "Error",
                  message: "Password Changed successfuly!",
                  color: "green",
                })
              : showNotification({
                  title: "Error",
                  message: "Wrong current password!",
                  color: "red",
                });
          })
          .catch((err) => console.error(err));
      } else {
        showNotification({
          title: "Error",
          message: "Password and confirm password did not match!",
          color: "red",
        });
      }
    } else if (tab === "3") {
      if (blockUser.blockUserId) {
        const options = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "content-type": "application/json",
          },
          body: JSON.stringify(blockUser),
        };

        fetch(`${backendUrl}user/blockUser`, options)
          .then((response) => response.json())
          .then((response) => {
            showNotification({
              title: "Blocked",
              message: "User Blocked Successfyly!",
              color: "green",
            });
            setRefetch((v) => !v);
          })
          .catch((err) => console.error(err));
      }
    }
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="e-settings-main">
        <h2 className="text-dark">Account Settings</h2>
        <div className="e-settings shadow-sm">
          <Tabs
            value={tab}
            onTabChange={setTab}
            variant="outline"
            // orientation="vertical"
            className="tabs"
          >
            <Tabs.List position="left">
              <Tabs.Tab value="1">Account Information</Tabs.Tab>
              <Tabs.Tab value="2">Password</Tabs.Tab>
              <Tabs.Tab value="3">Block Users</Tabs.Tab>
              {/* {userData.role === "Company" && (
                <Tabs.Tab value="4">My Posts</Tabs.Tab>
              )} */}
            </Tabs.List>
            <Tabs.Panel value="1" pt="xs">
              <AccountInfo
                acountInfo={acountInfo}
                setAccountInfo={setAccountInfo}
              />
            </Tabs.Panel>
            <Tabs.Panel value="2" pt="xs">
              <Password updatePass={updatePass} setUpdatePass={setUpdatePass} />
            </Tabs.Panel>
            <Tabs.Panel value="3" pt="xs">
              <BlockUser setBlockUser={setBlockUser} refetch={refetch} />
            </Tabs.Panel>
            {/* {userData.role === "Company" && (
              <Tabs.Panel value="4" pt="xs">
                <MyPosts />
              </Tabs.Panel>
            )} */}
          </Tabs>
          {tab !== "4" && (
            <div className="d-flex gap-2 mt-auto pt-2">
              <Button
                title="Cancel"
                onClick={() => navigate(routeNames.jobSeeker.dashboard)}
                style={{ marginTop: "auto" }}
              />
              <Button
                title="Save Settings"
                primary={true}
                // width="200px"
                style={{ marginTop: "auto" }}
                onClick={handleSaveData}
              />
            </div>
          )}
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
